// TenderDetailTabs - Tab components for Tender Detail page
export { default as SummaryTab } from './SummaryTab';
export { default as HistoricalsTab } from './HistoricalsTab';
export { default as SourcingTab } from './SourcingTab';
export { default as BidPrepTab } from './BidPrepTab';
export { default as FinancialTab } from './FinancialTab';
export { default as ComplianceTab } from './ComplianceTab';

// Tab configuration
export const TAB_CONFIG = [
  { id: 'summary', label: 'Summary', icon: '📋' },
  { id: 'historicals', label: 'Historicals', icon: '📜' },
  { id: 'sourcing', label: 'Sourcing', icon: '🏭' },
  { id: 'bidprep', label: 'Bid Prep', icon: '📝' },
  { id: 'financial', label: 'Financial analysis', icon: '💰' },
  { id: 'compliance', label: 'Bid Compliance', icon: '✓' }
];
